import React, { createContext, useCallback, useContext, useState } from 'react';

type TransferReservationToValidateCountContextValue = {
  /** Incrementa la versión para que el Sidebar (y otros consumidores) recarguen el amount */
  invalidateTransferReservationToValidateCount: () => void;
  /** Versión actual; al cambiar, los consumidores deben recargar los datos */
  invalidateVersion: number;
};

const TransferReservationToValidateCountContext =
  createContext<TransferReservationToValidateCountContextValue | null>(null);

export function TransferReservationToValidateCountProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [invalidateVersion, setInvalidateVersion] = useState(0);

  const invalidateTransferReservationToValidateCount = useCallback(() => {
    setInvalidateVersion((v) => v + 1);
  }, []);

  const value: TransferReservationToValidateCountContextValue = {
    invalidateTransferReservationToValidateCount,
    invalidateVersion
  };

  return (
    <TransferReservationToValidateCountContext.Provider value={value}>
      {children}
    </TransferReservationToValidateCountContext.Provider>
  );
}

export function useTransferReservationToValidateCount() {
  const ctx = useContext(TransferReservationToValidateCountContext);
  if (ctx == null) {
    throw new Error(
      'useTransferReservationToValidateCount must be used within TransferReservationToValidateCountProvider'
    );
  }
  return ctx;
}

